import { useTranslation } from 'react-i18next'

const GangStart = (props) => {
  const { t } = useTranslation()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="gang-start-title"
      fill="none"
      {...props}
    >
      <title id="gang-start-title">{t('antagonists:gang:components:start')}</title>
      <defs>
        <clipPath id="gang-b">
          <path
            d="M1602.79 929.02s-6.48 26.37-8.26 33.13c-2.39 9.08-.96 14.34-.96 14.34s25.63 7.81 27.69 10.9c2.06 3.08 2.28 11.16 14.6 12.96 21.95 3.2 30.9-4.09 32.69-5.58 1.41-1.18 1.53-9.66-.28-12.27-3.81-5.5-21.78-14.56-28.03-29.07-2.94-6.81-4.88-30.92-4.88-30.92l-32.56 6.5Z"
            style={{
              fill: '#222d44',
            }}
          />
        </clipPath>
        <clipPath id="gang-c">
          <path
            d="M1461.19 942.57s-9.26 27.49-9.98 30.08c-3.47 12.48-13.01 21.2-13.22 26.13-.21 4.94.03 8.63 3.13 10.01 8.06 3.58 25.91 2.88 32.9.82 6.99-2.06 8.84-5.14 9.67-8.64.82-3.5.65-10.82 1.44-11.72 3.13-3.59 11.86-8.45 11.86-8.45s-1.36-10.94-4.3-19.6c-1.79-5.27-3.24-13.29-3.24-13.29l-28.25-5.35Z"
            style={{
              fill: '#222d44',
            }}
          />
        </clipPath>
        <clipPath id="gang-d">
          <path
            d="M1474.68 618.01s-9.52 116.93-14.96 146.84c-5.44 29.91-8.71 107.24-8.71 128.99 0 21.75-1.76 61.89-1.76 61.89s9.27 12.54 25.59 10.5c16.32-2.04 26.73-9.46 26.73-9.46s7.69-74.84 8.37-108.83c.68-33.99 10.68-92.62 18.84-113.01s22.87-49.98 30.35-66.97c7.48-17 1.89-58.11 1.89-58.11l-86.34 8.16Z"
            style={{
              fill: '#44679e',
            }}
          />
        </clipPath>
        <clipPath id="gang-e">
          <path
            d="M1538.58 621.41s15.42 102.56 19.5 136.55c4.08 33.99 17.89 73.51 17.89 109.54s16.29 86.1 16.29 86.1 7.03 4.87 19.27 2.15c12.24-2.72 30.81-9.71 30.81-9.71s-6.21-45.14-13-82.53c-6.8-37.39-4.42-63.3-8.5-85.06-4.08-21.75 1.36-68.66 0-85.66s-11.56-71.38-11.56-71.38h-70.7Z"
            style={{
              fill: '#44679e',
            }}
          />
        </clipPath>
        <style>
          {
            '.f{fill:#f3f1e3}.g{fill:#f8c4b7}.h{fill:#f09b7d}.i{fill:#9e6c30}.j{fill:#8cabbc}.k{fill:#d0b46a}.l{fill:#d6d9dc}.m{fill:#222d44}.n{fill:#44679e}.o{fill:#4e3950}.p{stroke-dasharray:0 0 0 0 1.86 3.72 1.86 3.72}.p,.q,.r,.s,.t,.u,.v,.w{fill:none;stroke:#ffd500;stroke-linecap:round;stroke-width:1.59px}.r{stroke-dasharray:0 0 2.02 4.04}.s{stroke-dasharray:0 0 1.86 3.72}.t,.v,.w{stroke-linejoin:round}.u{stroke-dasharray:0 0 0 0 2.02 4.04 2.02 4.04}.x{clip-path:url(#gang-c)}.y{clip-path:url(#gang-b)}.aa{clip-path:url(#gang-d)}.v{stroke-dasharray:0 0 0 0 1.81 3.62 1.81 3.62}.w{stroke-dasharray:0 0 1.81 3.62}'
          }
        </style>
      </defs>
      <path
        d="M1602.79 929.02s-6.48 26.37-8.26 33.13c-2.39 9.08-.96 14.34-.96 14.34s25.63 7.81 27.69 10.9c2.06 3.08 2.28 11.16 14.6 12.96 21.95 3.2 30.9-4.09 32.69-5.58 1.41-1.18 1.53-9.66-.28-12.27-3.81-5.5-21.78-14.56-28.03-29.07-2.94-6.81-4.88-30.92-4.88-30.92l-32.56 6.5Z"
        style={{
          fill: '#222d44',
        }}
      />
      <g
        style={{
          clipPath: 'url(#gang-b)',
        }}
      >
        <path
          d="M1588.25 965.39s20.86 3.87 26.07 9.53c5.21 5.66 9.24 14.3 17.73 15.64 8.49 1.34 16.97 2.58 28.55-1.15 9-2.9 20.07-12.94 20.07-12.94l-1.7 37.93-96.54-9.98 5.81-39.03Z"
          style={{
            fill: '#8cabbc',
          }}
        />
      </g>
      <path
        d="M1461.19 942.57s-9.26 27.49-9.98 30.08c-3.47 12.48-13.01 21.2-13.22 26.13-.21 4.94.03 8.63 3.13 10.01 8.06 3.58 25.91 2.88 32.9.82 6.99-2.06 8.84-5.14 9.67-8.64.82-3.5.65-10.82 1.44-11.72 3.13-3.59 11.86-8.45 11.86-8.45s-1.36-10.94-4.3-19.6c-1.79-5.27-3.24-13.29-3.24-13.29l-28.25-5.35Z"
        style={{
          fill: '#222d44',
        }}
      />
      <g
        style={{
          clipPath: 'url(#gang-c)',
        }}
      >
        <path
          d="M1427.29 993.42s8.17 6.84 23.21 8.18c15.05 1.34 25.12-1.06 28.99-4.63 3.87-3.58 2.53-5.51 4.32-10.58 1.79-5.07 12.66-18.32 12.66-18.32l2.23 32.92-26.07 20.86-51.4-7.15 6.05-21.27Z"
          style={{
            fill: '#8cabbc',
          }}
        />
      </g>
      <path
        d="M1453.41 984s6.39-3.1 11.16-3.1 9.36 2.12 9.36 2.12l-.3 1.44s-6.13-2.39-9.48-2.06c-6.85.67-10.28 2.79-10.28 2.79l-.47-1.19ZM1453.62 978.02l.3 1.44s4.44-3.51 11.51-3.15 9.94 2.58 9.94 2.58l.51-1.08s-4.15-3.15-10.28-3.2c-6.13-.05-11.97 3.4-11.97 3.4Z"
        style={{
          fill: '#d6d9dc',
        }}
      />
      <path
        d="M1465.93 968.94c-8.01.12-12.61 4.49-12.61 4.49l.34 1.5s6.6-4.85 12.44-4.49c7.07.44 11.63 4.13 11.63 4.13l.8-1.03s-5.58-4.69-12.61-4.59ZM1453.28 967.44s6.18-6.55 15.4-4.9c8.94 1.6 11.47 5.21 11.47 5.21l-.72.83s-4.73-3.92-10.96-4.59c-10.03-1.08-14.68 4.54-14.68 4.54l-.51-1.08ZM1646.47 964.89s-6.86-.11-11.02 1.77c-4.3 1.94-7.7 5.81-7.7 5.81l.89 1.21s4.68-4.81 7.84-5.89c6.28-2.16 10.18-1.72 10.18-1.72l-.18-1.18ZM1643.5 960.12l.41 1.26s-5.27-1.17-11.19 1.75c-6.22 3.07-8.03 6.2-8.03 6.2l-.91-.75s2.62-4.39 8.09-6.78c5.25-2.3 11.63-1.68 11.63-1.68Z"
        style={{
          fill: '#d6d9dc',
        }}
      />
      <path
        d="M1629.31 957.4c6.8-2.66 12.39-.94 12.39-.94l.38 1.26s-7.5-1.42-12.33.91c-6.11 2.95-8.97 7.85-8.97 7.85l-1.14-.57s3.44-6.06 9.68-8.51ZM1639.2 952.04s-7.55-2.7-14.64 1.45c-7.37 4.31-8.49 8.16-8.49 8.16l.96.41s2.98-4.89 8.23-7.56c7.98-4.06 13.98-1.51 13.98-1.51l-.04-.95Z"
        style={{
          fill: '#d6d9dc',
        }}
      />
      <path
        d="M1517.32 374.11c-.02.64 3.84 19.74 1.96 25.22s-5.84 9.71-11.64 11.01-21.6 7.76-21.6 7.76l.52 44.15 103.54 9.08 1.86-45.29s-22.49-8.57-24.01-14.37c-1.52-5.81 1.18-30.99 1.18-30.99l-51.81-6.57Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
      <path
        d="M1545.1 292.58c-7.27.21-4.62 5.56-12.55 7.71-7.93 2.15-19.7 1.52-22.08 8.67-2.38 7.15 2.42 7.43-.63 11.77-3.06 4.34-5.84 12.27-4.27 18.41.73 2.84 2.32 10.02 3.53 13.4 1.4 3.94.06 13.44.06 13.44l69.8-2.72s-1.47-7.3.51-9.64c1.98-2.35 2.32-3.32 4.41-9.34 2.1-6.02-4.53-9.02-3.71-14.83.82-5.81-.35-16.75-5.71-23.38-5.36-6.64-16.76-3.07-18.66-7.19-1.9-4.12-6.51-6.42-10.7-6.3Z"
        style={{
          fill: '#d0b46a',
        }}
      />
      <path
        d="M1529.06 330.1c-3.94 2.76.73 8.9-5.82 11.48-6.55 2.58-10.77 3.71-9.6 6.66s-1.14 4.02-1.14 4.02-3.67-4.17-7.94-1.4c-4.27 2.78 0 15.59 1.5 20.46 1.49 4.87 2.89 4.78 5.03 5.36s3.97-1.14 3.97-1.14.08 9.38 3.5 13.42c3.42 4.04 13.36 14.25 17.33 17.04 3.97 2.79 14.35 3.12 18.9-.28 4.55-3.4 13.36-13.39 15.35-15.99 1.99-2.6 3.7-12.56 3.7-12.56s3.62 1.76 5.68.82c2.06-.95 4.73-9.23 6.35-12.22 1.62-2.99 1.88-11.1-1.37-12.47-3.25-1.37-7.47 3.69-7.47 3.69s-2.78-.22-1.25-4.35c1.53-4.13 4.93-7.57-2.75-9.22-7.68-1.64-17.47 7.05-24.21 3.79-6.74-3.26-4.2-11.42-8.36-15.86-4.17-4.44-9.29-2.71-11.37-1.25Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
      <path
        d="M1552.63 354.31s10.93-4.85 12.96-4.78c2.03.07 6.32.71 6.32.71l-.19 1.9s-7.1.15-9.95 1.96c-2.85 1.81-6.84 3.84-6.84 3.84l-2.29-3.62ZM1540.24 352.55s-11.47-3.38-13.47-3.05c-2 .33-6.17 1.53-6.17 1.53l.43 1.85s7.06-.78 10.12.65c3.06 1.42 7.28 2.91 7.28 2.91l1.8-3.89Z"
        style={{
          fill: '#9e6c30',
        }}
      />
      <path
        d="M1533.05 390.06c.2 1.07 1.88.4 2.8 1.6.93 1.2 4.45 3.04 9.41 3.13 1.6.76 4.48-.33 5.88-.81 1.4-.48 3.32-2.55 4.36-2.79s2.5-.54 2.46-1.64c-.03-1.1-6.47-2.27-8.68-2.28-2.2 0-3.21 1.34-3.9 1.25-.69-.09-1.69-1.16-3.47-1.21-1.79-.06-4.86 1.22-5.62 1.33s-3.48.17-3.24 1.42Z"
        style={{
          fill: '#f09b7d',
        }}
      />
      <path
        style={{
          fill: '#4e3950',
        }}
        d="m1524.21 357.09 4.29 1.72 1.14-2.93-4.77-.5-.66 1.71z"
      />
      <path
        d="M1530.68 355.3c-2.14.13-3.56 1.66-3.35 3.76.21 2.09 1.62 2.87 3.55 2.87 2.28 0 3.49-1.45 3.5-3.62 0-1.54-1.49-3.14-3.69-3.01ZM1565.62 357.98l-4.26 2.59-1.14-2.72 4.51-1.46.89 1.59z"
        style={{
          fill: '#4e3950',
        }}
      />
      <path
        d="M1558.36 357.08c2.13-.28 3.81.96 4.01 3.06.19 2.1-1.05 3.12-2.94 3.49-2.24.44-3.7-.76-4.12-2.89-.29-1.51.87-3.37 3.06-3.65Z"
        style={{
          fill: '#4e3950',
        }}
      />
      <path
        d="M1445.63 489.98s-9.43 45.02-11.58 55.74c-2.14 10.72 2.57 20.15 14.15 21.87 11.58 1.71 14.58-15.86 17.15-23.15 2.57-7.29 10.72-46.73 10.72-46.73l-30.44-7.72Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
      <path
        d="M1448.73 531.78c-11.37-.31-15.2 11.59-15.46 20.09-.26 8.5.77 40.7 2.83 51.26 2.06 10.56 5.15 24.21 5.15 24.21l21.38-5.67s-1.55-4.89-.52-18.8 3.11-52.22 3.23-58.44c.12-6.22-7.09-12.4-16.63-12.66ZM1602.77 509.62s12.11 37.09 15.46 44.31c3.35 7.21 6.18 15.2 17.26 15.46s12.11-13.14 10.05-20.61c-2.06-7.47-14.17-50.23-14.17-50.23l-28.59 11.08Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
      <path
        d="M1629.82 530.23c-8.81-.25-13.4 16.49-11.59 36.32 1.8 19.83 7.99 60.02 7.99 60.02l19.58 5.15s4.12-62.34 3.35-71.35c-.77-9.02-10.3-29.88-19.32-30.14Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
      <path
        d="M1474.68 618.01s-9.52 116.93-14.96 146.84c-5.44 29.91-8.71 107.24-8.71 128.99 0 21.75-1.76 61.89-1.76 61.89s9.27 12.54 25.59 10.5c16.32-2.04 26.73-9.46 26.73-9.46s7.69-74.84 8.37-108.83c.68-33.99 10.68-92.62 18.84-113.01s22.87-49.98 30.35-66.97c7.48-17 1.89-58.11 1.89-58.11l-86.34 8.16Z"
        style={{
          fill: '#44679e',
        }}
      />
      <g
        style={{
          clipPath: 'url(#gang-d)',
        }}
      >
        <path
          d="M1441.72 941.05s.2.29.58.8"
          style={{
            fill: 'none',
            stroke: '#ffd500',
            strokeLinecap: 'round',
            strokeWidth: '1.59px',
          }}
        />
        <path
          d="M1444.67 944.72c.73.82 1.59 1.73 2.57 2.68"
          style={{
            fill: 'none',
            stroke: '#ffd500',
            strokeDasharray: '0 0 1.86 3.72',
            strokeLinecap: 'round',
            strokeWidth: '1.59px',
          }}
        />
        <path
          d="M1448.6 948.68c5.13 4.64 12.91 9.79 22.58 10.37 14.41.87 30.91-9.08 36.92-13.1"
          style={{
            fill: 'none',
            stroke: '#ffd500',
            strokeDasharray: '0 0 0 0 1.86 3.72 1.86 3.72',
            strokeLinecap: 'round',
            strokeWidth: '1.59px',
          }}
        />
        <path
          d="M1509.64 944.9c.53-.37.81-.58.81-.58"
          style={{
            fill: 'none',
            stroke: '#ffd500',
            strokeLinecap: 'round',
            strokeWidth: '1.59px',
          }}
        />
      </g>
      <path
        d="M1538.58 621.41s15.42 102.56 19.5 136.55c4.08 33.99 17.89 73.51 17.89 109.54s16.29 86.1 16.29 86.1 7.03 4.87 19.27 2.15c12.24-2.72 30.81-9.71 30.81-9.71s-6.21-45.14-13-82.53c-6.8-37.39-4.42-63.3-8.5-85.06-4.08-21.75 1.36-68.66 0-85.66s-11.56-71.38-11.56-71.38h-70.7Z"
        style={{
          fill: '#44679e',
        }}
      />
      <g
        style={{
          clipPath: 'url(#gang-e)',
        }}
      >
        <path
          d="m1576.44 945.96.97.23"
          style={{
            fill: 'none',
            stroke: '#ffd500',
            strokeLinecap: 'round',
            strokeWidth: '1.59px',
          }}
        />
        <path
          d="M1581.35 947.05c1.17.25 2.51.52 3.97.79"
          style={{
            fill: 'none',
            stroke: '#ffd500',
            strokeDasharray: '0 0 2.02 4.04',
            strokeLinecap: 'round',
            strokeWidth: '1.59px',
          }}
        />
        <path
          d="M1587.3 948.21c8.5 1.52 19.76 2.92 25.14 1.02 7.35-2.59 24.65-8.28 31.5-10.52"
          style={{
            fill: 'none',
            stroke: '#ffd500',
            strokeDasharray: '0 0 0 0 2.02 4.04 2.02 4.04',
            strokeLinecap: 'round',
            strokeWidth: '1.59px',
          }}
        />
        <path
          d="M1645.86 938.09c.61-.2.94-.31.94-.31"
          style={{
            fill: 'none',
            stroke: '#ffd500',
            strokeLinecap: 'round',
            strokeWidth: '1.59px',
          }}
        />
      </g>
      <path
        d="M1560.37 627.65s.02.36.04.99"
        style={{
          fill: 'none',
          stroke: '#ffd500',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.59px',
        }}
      />
      <path
        d="M1560.55 632.26c.04 1.08.08 2.3.12 3.62"
        style={{
          fill: 'none',
          stroke: '#ffd500',
          strokeDasharray: '0 0 1.81 3.62',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.59px',
        }}
      />
      <path
        d="M1560.73 637.69c.19 6.51.35 14.5.1 18.58-.31 5.04-5.13 6.98-8.31 7.71"
        style={{
          fill: 'none',
          stroke: '#ffd500',
          strokeDasharray: '0 0 0 0 1.81 3.62 1.81 3.62',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.59px',
        }}
      />
      <path
        d="M1550.73 664.31c-.61.08-.99.1-.99.1"
        style={{
          fill: 'none',
          stroke: '#ffd500',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.59px',
        }}
      />
      <path
        d="M1508.45 409.72s16.08 23.4 36.56 22.91c20.47-.49 28.76-16.08 28.76-16.08s43.07 20.59 45.03 21.79c1.96 1.2-3.34 31.2-9.66 40.98-6.32 9.78 0 39.29 1.81 58.41 1.81 19.12 5.42 99.2 5.42 99.2s-5.47-.53-13.4 2.48c-10.95 4.16-27.42 12.26-48.12 12.5-35.69.41-58.81-6.49-65.71-6.08-6.9.41-17.44.41-17.44.41s-4.46-6.08-3.65-19.88c.81-13.79 4.87-27.18 11.36-48.27 6.49-21.09 3.65-79.5 0-97.35-3.65-17.85-23.74-50.16-16.85-54.22 6.9-4.06 45.92-16.8 45.92-16.8Z"
        style={{
          fill: '#f3f1e3',
        }}
      />
      <path
        d="M1428.68 498.18s17.04 5.68 27.99 9.73c10.95 4.06 29.61 3.24 29.61 3.24s-7.3-93.7-22.31-85.59c-15.01 8.11-19.47 37.72-24.34 45.83-4.87 8.11-10.95 26.77-10.95 26.77ZM1617.55 438.07c-9.75-1.83-20.55 80.8-20.55 80.8s11.36-2.84 23.93-3.65 30.57-13.46 30.57-13.46-10.88-16.94-13.32-27.48c-2.43-10.55-10.24-34.25-20.64-36.2Z"
        style={{
          fill: '#f3f1e3',
        }}
      />
      <path
        d="M1440.51 623.51s2.35 16.65 3.58 21.93c1.23 5.28 14.6 44.69 16.36 48.21 1.76 3.52 11.26 13.9 11.26 13.9s3.48-2.57 2.17-5.81c-1.32-3.24-6.81-9.61-7.03-10.76s-.49-5.99-.49-5.99 3.25 7.76 4.22 9.15c1.18 1.68 15.6 18.25 15.6 18.25s4.5-1.92 2.14-6.09-11-13.99-11-13.99-2.84-5.94-2.07-6.22c.77-.27 7.25 7.74 8.95 8.9s15.7 12.74 15.7 12.74 4.02-2.56 1.16-6.46c-2.86-3.9-11.21-10.51-12.58-12.54-1.37-2.03-8.02-9.17-6.31-10.27 1.7-1.1 9.28 6.97 10.65 8.02 1.37 1.04 14.77 10.71 14.77 10.71s3.1-3.13.13-6.21c-2.97-3.07-10.87-10-12.08-11.48s-8.77-13.98-9.28-17.8c-.51-3.82-.76-7.78.51-9.05s7.65-6.12 7.65-6.12-4.47-4.35-7.66-4.86c-3.19-.51-14.8 1.9-17.48-1.04-2.68-2.93-8.04-27.59-8.04-27.59l-20.85 10.47ZM1602.55 639.55s4.98-2.88 10.62-2.43c5.64.44 7.52 1.88 9.51-.33 1.99-2.21.89-27.83.89-27.83s23.66 4.93 23.33 4.93 0 23.11-1.55 27.87c-1.55 4.76-7.41 32.51-7.96 35.28-.55 2.76-9.64 11.44-10.19 12.88-.55 1.44-9.82 13.11-9.82 13.11s-2.19-1.28-1.61-3.9c.36-1.6 2.43-4.56 2.43-4.56l-14.09 11.23s-3.1-3.43-1.22-5.86c1.88-2.43 12.72-12.05 12.72-12.05s2.88-3.65 2.32-4.31c-.55-.66-20.35 19.46-20.35 19.46s-3.41-3.54-1.2-7.85 14.91-15.37 13.8-17.25c-1.11-1.88-18.25 15.7-18.25 15.7s-4.36-3.74-.93-8.38 16.74-18.93 19.4-23.91c2.65-4.98 1.88-8.18.55-10.28-1.33-2.1-2.76-4.31-2.76-4.31s-5.42-7.3-5.64-7.19Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
    </svg>
  )
}
export default GangStart
